export enum SustainabilityIconName {
  SustainabilityFabric = 'SustainabilityFabric',
  SustainabilityFactory = 'SustainabilityFactory',
  SustainabilityFair = 'SustainabilityFair',
}

export const sustainabilityIconAssets: {
  [key in SustainabilityIconName]: string;
} = {
  [SustainabilityIconName.SustainabilityFabric]: require('./ic-sust-fabric.svg'),
  [SustainabilityIconName.SustainabilityFactory]: require('./ic-sust-factory.svg'),
  [SustainabilityIconName.SustainabilityFair]: require('./ic-sust-fair.svg'),
};
